<template>
  <div class="myhome-app">
    <StudentParentModal v-if="studentParentModalVisible" :visible="studentParentModalVisible" />
    <template v-else>
      <keep-alive v-if="eventsLoaded">
        <router-view
          :class="['main-container', { 'main-container-home': $route.name === 'home' }]"
          :books="books"
          :books-agent="booksAgent"
          :aed="aed"
          :children-books="childrenBooks"
          :children-aed="childrenAed"
          :user="user"
          :events="events.slice(0, 3)"
          :page-limit="24"
          :search-endpoint="searchEndPoint"
        ></router-view>
      </keep-alive>
      <Loader v-else-if="!errorModalVisible" class="dea-loader dea-loader--myhome" />
      <LoadingErrorModal v-if="errorModalVisible" :visible="errorModalVisible" />
    </template>
  </div>
</template>

<script>
import * as Sentry from "@sentry/vue";
import { mapActions, mapGetters } from "vuex";

import Loader from "@/components/elements/Loader";
import HandleWindowResize from "@/components/mixins/handleWindowResize";
import LoadingErrorModal from "../components/LoadingErrorModal";
import StudentParentModal from "../components/StudentParentModal.vue";

export default {
  name: "MyHome",
  components: {
    Loader,
    LoadingErrorModal,
    StudentParentModal,
  },
  mixins: [HandleWindowResize],
  props: {
    showModalError: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      aed: [],
      books: [],
      booksAgent: [],
      childrenBooks: {},
      childrenAed: {},
      events: [],
      eventsLoaded: false,
      showMenu: false,
      errorModalVisible: this.showModalError,
      studentParentModalVisible: false,
      sourceBooks: [],
    };
  },
  computed: {
    ...mapGetters(["filterRegistrations", "registrationsLoaded", "user", "ticketFilter", "viewChanged"]),
    degreesList() {
      return this.$root.asyncConf.degrees_json || [];
    },
    searchEndPoint() {
      if (this.$root.asyncConf) {
        return this.$root.asyncConf.searchApi;
      }
      return "";
    },
  },
  watch: {
    "trigger": function() {
      this.getData();
    },
    "$store.state.registrations.registrationsLoaded": function() {
      this.getUserEvents();
    },
    "$route": function updatedRoute() {
      this.showMenu = false;
    },
    "user": function() {
      if (this.user && this.user.datiLogin && this.user.datiLogin.bceId) {
        this.$store.commit("setUser", this.user, false);
      }
    },
    "showModalError": function(value) {
      this.errorModalVisible = value;
    },
  },
  created() {
    window.addEventListener("orientationchange", () => {
      this.showMenu = false;
    });
  },
  mounted() {
    this.getData();
  },
  methods: {
    ...mapActions(["fetchMessages", "fetchRegistrations", "fetchFiscalCode"]),
    /**
     * Get latest events from vuex state
     */
    async getUserEvents() {
      if (this.user.datiLogin.seiUn !== "studente" && this.user.datiLogin.seiUn !== "genitore") {
        if (!this.registrationsLoaded && !this.viewChanged) {
          await this.fetchRegistrations();
        }
        this.events = this.filterRegistrations("future");
        this.eventsLoaded = true;
      } else {
        this.events = [];
        this.eventsLoaded = true;
        this.studentParentModalVisible = true;
      }
    },
    /**
     * General entry point for loading data.
     *
     * This is called after the user has been loaded and we thus have a valid user at `this.user`
     */
    async getData() {
      Sentry.setUser({ username: this.user.datiLogin.bceId, ip_address: "{{ auto }}" });
      document.title = `Area Personale - ${this.user.datiLogin.nome}`;
      await this.getUserEvents();
      await this.fetchFiscalCode();
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";
@import "~/scss/_local-variables"; //sass-lint:disable-line clean-import-paths

$header-center-main-top: $dea-header-top-height;
$header-center-main-top-mobile: 0;
$main-container-top: 66px;
$loader-home-padding-top: 200px;

.main-container {
  position: relative;

  &-home {
    @include media("<=m") {
      top: $header-center-main-top-mobile;
    }

    top: $header-center-main-top;
  }
}

.dea-links--chip {
  padding: 0 $space-base;

  &:first-of-type {
    padding-left: 0;
  }
}

.dea-links__label--chip {
  min-width: auto;
}

.dea-chip--inline {
  border-radius: $border-radius-circle;
  display: inline-block;
  margin-left: $space-x-small;
  min-width: $dea-size-medium;
  padding: 0 1px 0 0;

  .dea-chip__label {
    transform: none;
  }
}

.dea-loader--myhome {
  padding: $loader-home-padding-top 0;
}

.empty-book-section__buttons {
  .dea-button {
    display: inline-flex;
  }
}

.dea-main-header__dea-logo--personal-area {
  align-items: center;

  .header-center-main__area-personale-logo {
    height: $space-base;
    transform: none;
  }
}
</style>
